import { useTranslation } from 'react-i18next'
import React from 'react'

import CollapsibleList from '@/components/CollapsibleList'
import SettingControl from '../SettingControl'

export default function DatamartSettings () {
  const [expand, setExpand] = React.useState(false)
  const { t } = useTranslation()

  const setting = {
    label: t('datamart.settings.enabled'),
    paramaterName: 'datamartConfig.enabled',
    type: 'switch',
  }

  return (
    <CollapsibleList title={t('datamart.settings.title')} expand={expand} setExpand={setExpand}>
      <SettingControl setting={setting} />
    </CollapsibleList>
  )
}
